<ion-header>
    <ion-toolbar class="search-program-toolbar">
        <ion-title class="ion-text-center">Filters</ion-title>
        <ion-button slot="end" class="close-btn" type="button" fill="clear" (click)="dismiss()">
            <ion-icon slot="icon-only" color="dark" name="close" size="medium"></ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-grid *ngIf="content">
        <ion-row>
            <ion-col>
                <section class="selections-section" *ngIf="selectionsList.length > 0">
                    <ion-list-header class="search-program-list-header">Selections</ion-list-header>
                    <div class="selections-chips">
                        <ion-chip *ngFor="let sel of selectionsList; trackBy: trackBySelection" class="selection-chip">
                            <ion-label>{{ sel.label }}</ion-label>
                            <ion-icon name="close-circle" (click)="removeSelection(sel.category, sel.item); $event.stopPropagation()" class="chip-remove"></ion-icon>
                        </ion-chip>
                    </div>
                </section>
                <ion-list-header class="search-program-list-header"> Select program features </ion-list-header>
                <ion-list class="filter-list accordion-list">
                    <!-- Medical Specialty -->
                    <ion-item button class="filter-row-item" [class.accordion-row-selected]="selectedSpecialtyValue?.length > 0" (click)="openSelect($event, 'specialty')" detail="false">
                        <ion-label>Medical Specialty</ion-label>
                        <span class="accordion-right" slot="end">
                            <span class="accordion-selections">{{ selectedSpecialtyValue?.length || 0 }} selected</span>
                            <fa-icon class="accordion-chevron" [icon]="faChevronDown"></fa-icon>
                        </span>
                    </ion-item>
                    <!-- Rotation Type -->
                    <ion-item button class="filter-row-item" [class.accordion-row-selected]="selectedTypeValue?.length > 0" (click)="openSelect($event, 'type')" detail="false">
                        <ion-label>Rotation Type</ion-label>
                        <span class="accordion-right" slot="end">
                            <span class="accordion-selections">{{ selectedTypeValue?.length || 0 }} selected</span>
                            <fa-icon class="accordion-chevron" [icon]="faChevronDown"></fa-icon>
                        </span>
                    </ion-item>
                    <!-- Months -->
                    <ion-item button class="filter-row-item" [class.accordion-row-selected]="selectedDateValue?.length > 0" (click)="openSelect($event, 'dates')" detail="false">
                        <ion-label>Months</ion-label>
                        <span class="accordion-right" slot="end">
                            <span class="accordion-selections">{{ selectedDateValue?.length || 0 }} selected</span>
                            <fa-icon class="accordion-chevron" [icon]="faChevronDown"></fa-icon>
                        </span>
                    </ion-item>
                    <!-- Tags -->
                    <ion-item button class="filter-row-item" [class.accordion-row-selected]="selectedTagValue?.length > 0" (click)="openSelect($event, 'tag')" detail="false">
                        <ion-label>Tags</ion-label>
                        <span class="accordion-right" slot="end">
                            <span class="accordion-selections">{{ selectedTagValue?.length || 0 }} selected</span>
                            <fa-icon class="accordion-chevron" [icon]="faChevronDown"></fa-icon>
                        </span>
                    </ion-item>
                    <!-- States -->
                    <ion-item button class="filter-row-item" [class.accordion-row-selected]="selectedStateValue?.length > 0" (click)="openSelect($event, 'states')" detail="false">
                        <ion-label>States</ion-label>
                        <span class="accordion-right" slot="end">
                            <span class="accordion-selections">{{ selectedStateValue?.length || 0 }} selected</span>
                            <fa-icon class="accordion-chevron" [icon]="faChevronDown"></fa-icon>
                        </span>
                    </ion-item>
                    <!-- Cities -->
                    <ion-item button class="filter-row-item" [class.accordion-row-selected]="selectedCityValue?.length > 0" (click)="openSelect($event, 'cities')" detail="false">
                        <ion-label>Cities</ion-label>
                        <span class="accordion-right" slot="end">
                            <span class="accordion-selections">{{ selectedCityValue?.length || 0 }} selected</span>
                            <fa-icon class="accordion-chevron" [icon]="faChevronDown"></fa-icon>
                        </span>
                    </ion-item>
                </ion-list>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>
<ion-footer class="search-program-footer">
    <button type="button" class="footer-clear-all" (click)="reset()">Clear All</button>
    <ion-button expand="full" class="footer-search-btn ion-text-wrap" color="secondary" (click)="runSearch()">{{ searchButtonText }}</ion-button>
</ion-footer>
